var DEFAULT_LOGIN_PATH = '/login';
var DEFAULT_POST_LOGIN_PATH = '/';
var AUTH_SCREEN_PATTERNS = [
    /\/login\/?$/i,
    /\/auth\/callback\/?$/i,
    /\/oauth2\/redirect\/?$/i,
    /\/oauth2\/callback\/?$/i
];
var normalizeCandidate = function(raw) {
    if (!raw) return null;
    var trimmed = raw.trim();
    if (!trimmed) return null;
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    return trimmed.startsWith('/') ? trimmed : "/".concat(trimmed);
};
var candidatePathname = function(candidate) {
    var _candidate_split_;
    if (/^https?:\/\//i.test(candidate)) {
        try {
            return new URL(candidate).pathname;
        } catch (e) {
            return candidate;
        }
    }
    return ((_candidate_split_ = candidate.split('?')[0]) === null || _candidate_split_ === void 0 ? void 0 : _candidate_split_.split('#')[0]) || candidate;
};
var isAuthScreenPath = function(candidate) {
    var path = candidatePathname(candidate);
    return AUTH_SCREEN_PATTERNS.some(function(pattern) {
        return pattern.test(path);
    });
};
export var extractOriginalUrlFromOAuthState = function(state) {
    if (!state) return null;
    try {
        var normalized = state.replace(/-/g, '+').replace(/_/g, '/');
        var padding = normalized.length % 4 === 0 ? '' : '='.repeat(4 - normalized.length % 4);
        var decoded = atob("".concat(normalized).concat(padding));
        var parsed = JSON.parse(decoded);
        return typeof parsed.originalUrl === 'string' ? parsed.originalUrl : null;
    } catch (e) {
        return null;
    }
};
export var resolveOAuthLoginPath = function(config) {
    var _config_routes;
    return normalizeCandidate((_config_routes = config.routes) === null || _config_routes === void 0 ? void 0 : _config_routes.loginPath) || DEFAULT_LOGIN_PATH;
};
export var resolveOAuthPostLoginPath = function(config, storedRedirect, stateParam) {
    var _config_routes;
    var configuredFallback = normalizeCandidate((_config_routes = config.routes) === null || _config_routes === void 0 ? void 0 : _config_routes.postLoginPath) || DEFAULT_POST_LOGIN_PATH;
    var candidates = [
        normalizeCandidate(storedRedirect),
        normalizeCandidate(extractOriginalUrlFromOAuthState(stateParam))
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = candidates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var candidate = _step.value;
            if (!candidate) continue;
            if (!isAuthScreenPath(candidate)) {
                return candidate;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return configuredFallback;
};
